import { GREY_DROPDOWN_CARET } from '../../assets/hostedassets';
import { StatusDropdownOption } from '../../common/_custom/StatusDropdown/StatusDropdown';
import { INVESTOR_ROUTES, LENDER_ROUTES } from './routesConst';

export type uiStyleType = {
    buttons?: {
        primary?: {
            textColour?: string;
            backgroundColour?: string;
        };
        secondary?: {
            textColour?: string;
            borderColour?: string;
            backgroundColour?: string;
        };
        tertiary?: {
            textColour?: string;
        };
    };
    tabs?: {
        active?: {
            textColour?: string;
            backgroundColour?: string;
        };
        inactive?: {
            textColour?: string;
            backgroundColour?: string;
        };
    };
    backgrounds?: {
        primary?: {
            backgroundColour?: string;
        };
        secondary?: {
            backgroundColour?: string;
        };
    };
    texts?: {
        primary?: {
            textColour?: string;
        };
    };
    borders?: {
        primary?: {
            borderColour?: string;
        };
    };
};

export enum ROOT_TYPE {
    BORROWER = 'borrower',
    INVESTOR = 'investor',
    LENDER = 'lender',
}

export const getRouteType = (currentPath: string): ROOT_TYPE.BORROWER | ROOT_TYPE.LENDER | ROOT_TYPE.INVESTOR => {
    if (Object.values(INVESTOR_ROUTES).some((route) => currentPath.startsWith(route))) {
        return ROOT_TYPE.INVESTOR;
    }
    if (Object.values(LENDER_ROUTES).some((route) => currentPath.startsWith(route))) {
        return ROOT_TYPE.LENDER;
    }
    return ROOT_TYPE.BORROWER;
};

export const defaultUiStyle: uiStyleType = {
    buttons: {
        primary: {
            textColour: '#FFFFFF',
            backgroundColour: '#6021b3',
        },
        secondary: {
            textColour: '#6021b3',
            borderColour: '#c7c7c7',
            backgroundColour: '#FFFFFF',
        },
        tertiary: {
            textColour: '#6021b3',
        },
    },
    tabs: {
        active: {
            textColour: '#6021b3',
            backgroundColour: '#f9f5ff',
        },
        inactive: {
            textColour: '#AAAAAA',
            backgroundColour: '#f7f7f7',
        },
    },
    backgrounds: {
        primary: {
            backgroundColour: '#6021b3',
        },
        secondary: {
            backgroundColour: '#f9f5ff',
        },
    },
    texts: {
        primary: {
            textColour: '#6021b3',
        },
    },
    borders: {
        primary: {
            borderColour: '#6021b3',
        },
    },
};

export const ONE_DAY_IN_MILLISECONDS = 24 * 60 * 60 * 1000;

export const TIME_DATE_FORMAT = 'hh:mm A, DD MMM YYYY';

export const DATE_FORMAT = 'DD MMM YYYY';

export const CREATE_DEAL = 'CREATE_DEAL';

export const RELATED_COMPANIES_NETWORK_TOOLTIP =
    'Discover how this entity is connected across the AICA ecosystem through its Customer and Vendor relationships';
export const AICA_REPORT_AVAILABLE_TOOLTIP = 'AICA Report available';

export const MULTIPLE_LOGIN_TOAST_ERROR = 'You’re already logged in from another tab. Please log in here to continue.';
export const INVALID_SESSION_ERROR_MESSAGE = 'Session Expired, Please Log-in Again';

export const TAB_TO_TASK_TRACKER_MAP: { [key: string]: string[] } = {
    overview: [
        'AION_KARZA_MCA_LIVE',
        'AION_FETCH_MCA_CHARGES_DATA',
        'AION_FETCH_SHAREHOLDERS_DATA',
        'AION_FETCH_SHAREHOLDING_PATTERN_DATA',
        'AION_FETCH_FUNDING_HISTORY',
        'AION_AUDITED_FINANCIAL_CHECK',
        'AION_AUDITED_FINANCIAL_CHECK_BEFORE_MCA_REFRESH',
        'AION_AUDITED_FINANCIAL_CHECK_AFTER_MCA_REFRESH',
    ],
    relatedParty: ['AION_INGEST_RELATED_PARTIES_DATA'],
    compliances: ['AION_GST_TRANSACTIONS_FETCH_INGEST'],
    legalChecks: ['AION_INGEST_LITIGATION_CLASSIFICATION_DATA', 'AION_INGEST_AML_PEP_DATA'],
    auditedFinancials: ['AION_AUDITED_FINANCIAL_UNLOCK'],
    bankingAndFinancials: ['AION_BANKING_TAB_UNLOCK'],
    creditBureau: ['AION_FETCH_MCA_CHARGES_DATA'], // Setting to MCA Charges for now since it should be open on report unlock
};

export enum TabModule {
    OVERVIEW = 'overview',
    RELATED_PARTY = 'relatedParty',
    COMPLIANCES = 'compliances',
    LEGAL_CHECKS = 'legalChecks',
    AUDITED_FINANCIALS = 'auditedFinancials',
    CREDIT_BUREAU = 'creditBureau',
    REVENUE = 'revenue',
    VENDOR_EXPENSES = 'vendorExpenses',
    BANKING_AND_FINANCIALS = 'bankingAndFinancials',
    reconciliation = 'reconciliation',
}

export const BOOLEAN_CHOICE = {
    YES: 'Yes',
    NO: 'No',
};

export const VIEW_CONFIGS = {
    AICA_DEAL_NAVBAR_VIEW: 'AICA_DEAL_NAVBAR_VIEW',
    AICA_VISIBILITY: 'AICA_VISIBILITY',
};

export const DESIGNATION = {
    ADMIN: 'Admin',
    TEAM_MEMBER: 'Team Member',
};

export enum ApiStatus {
    IDLE = 'idle',
    PENDING = 'pending',
    SUCCESS = 'success',
    ERROR = 'error',
}

export const ALL_ACCOUNTS = 'All Accounts';
export const AGGREGATED = 'aggregated';

// Sort direction constants
export const SORT_DIRECTIONS = {
    ASC: 'ASC' as const,
    DESC: 'DESC' as const,
};

export type SortDirection = (typeof SORT_DIRECTIONS)[keyof typeof SORT_DIRECTIONS] | null;

export type SortConfig = {
    field: string;
    direction: SortDirection;
    fieldType?: string;
};
export const defaultOptionValue: StatusDropdownOption = {
    label: '',
    value: '',
    backgroundColor: '#F5F5F5',
    labelColor: '#B4B4B4',
    customCaret: GREY_DROPDOWN_CARET,
};

export const HEADERS = {
    X_REQUESTED_ORGANIZATION_ID: 'x-requested-organization-id',
};

export const TALK_TO_US_OWNERS = {
    PARTNER: { name: 'Naman Verma', phone: '8951392730' },
    LENDER: { name: 'Sudhanshu Bhasin', phone: '7506038812' },
    BORROWER: { name: 'Pragya Rathi', phone: '8951743181' },
};

export enum MANDATE_STATES {
    DRAFT = 'DRAFT',
    SHARED = 'SHARED',
    LOST = 'LOST',
}

export enum NOTIFICATION_MODAL {
    CONTACT_US = 'contactUs',
    DEFAULT = 'default',
}

export enum QUALIFICATION_STATUS {
    QUALIFIED = 'Qualified',
    UNQUALIFIED = 'Unqualified',
}

export enum DISPATCH_EVENTS {
    REQUIREMENT_UPDATED = 'requirement-updated',
}

export enum KEYBOARD_EVENTS {
    ENTER = 'Enter',
    BACKSPACE = 'Backspace',
    ESCAPE = 'Escape',
    DELETE = 'Delete',
}

export enum TALK_TO_US {
    HEADER = 'Talk to Us',
    CONTENT = 'Call your dedicated Relationship Manager',
}

export const REPORT_TAB_KEYS = {
    AICA_REPORT: 'aicaReport',
    DATA_ROOM: 'dataRoom',
    OVERVIEW: 'Overview',
} as const;
